import './gestor/gestor-form';

$(function () {

    // Detectar envío del formulario: deshabilitar botones y mostrar spinner
    // Sólo ejecutar si la validación anterior NO previno el submit
    $("form").on("submit", function (e) {
        if (e.isDefaultPrevented && e.isDefaultPrevented()) {
            // Validación previa (capture) canceló el envío
            return;
        }
        window.Gestor = window.Gestor || {};
        window.Gestor.formSubmitted = true;
        $(this).find('button[type="submit"]').each(function () {
            var $btn = $(this);
            $btn.prop('disabled', true);
            $btn.html('<span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...');
        });
    });

    // Initialize Dropzone (actual handlers are centralized in gestor-form.js)
    if (typeof window.initializeGestorDropzone === "function") {
        window.initializeGestorDropzone();
    }
});
